import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../Common/Header';
import './PollPercentage.css';

const PollPercentage = () => {
  const { t } = useTranslation();
  
  // Updated Poll Data - Bihar Legislative Assembly Elections 2025
  const rawPollData = [
    { district: 'MADHEPURA', percentage: 69.59 },
    { district: 'SAHARSA', percentage: 69.38 },
    { district: 'DARBHANGA', percentage: 63.66 },
    { district: 'MUZAFFARPUR', percentage: 71.81 },
    { district: 'GOPALGANJ', percentage: 66.64 },
    { district: 'SIWAN', percentage: 60.61 },
    { district: 'SARAN', percentage: 63.86 },
    { district: 'VAISHALI', percentage: 68.50 },
    { district: 'SAMASTIPUR', percentage: 71.74 },
    { district: 'BEGUSARAI', percentage: 69.87 },
    { district: 'KHAGARIA', percentage: 67.90 },
    { district: 'MUNGER', percentage: 62.74 },
    { district: 'LAKHISARAI', percentage: 64.98 },
    { district: 'SHEIKHPURA', percentage: 61.99 },
    { district: 'NALANDA', percentage: 59.81 },
    { district: 'PATNA', percentage: 59.02 },
    { district: 'BHOJPUR', percentage: 59.90 },
    { district: 'BUXAR', percentage: 61.97 },
    { district: 'GAYA', percentage: 68.78 },
    { district: 'KAIMUR', percentage: 68.57 },
    { district: 'ROHTAS', percentage: 62.62 },
    { district: 'AURANGABAD', percentage: 65.47 },
    { district: 'ARWAL', percentage: 63.88 },
    { district: 'JEHANABAD', percentage: 65.39 },
    { district: 'NAWADA', percentage: 57.86 },
    { district: 'BHAGALPUR', percentage: 67.75 },
    { district: 'BANKA', percentage: 70.75 },
    { district: 'JAMUI', percentage: 69.72 },
    { district: 'SITAMARHI', percentage: 67.21 },
    { district: 'SHEOHAR', percentage: 68.80 },
    { district: 'MADHUBANI', percentage: 63.80 },
    { district: 'SUPAUL', percentage: 72.82 },
    { district: 'PURNIA', percentage: 76.45 },
    { district: 'ARARIA', percentage: 70.62 },
    { district: 'KATIHAR', percentage: 79.10 },
    { district: 'KISHANGANJ', percentage: 78.16 },
    { district: 'EAST CHAMPARAN', percentage: 71.57 },
    { district: 'WEST CHAMPARAN', percentage: 71.38 }
  ];

  // Calculate ranks based on percentage (highest to lowest)
  const pollData = rawPollData
    .sort((a, b) => b.percentage - a.percentage)
    .map((item, index) => ({
      ...item,
      rank: index + 1
    }));

  // Calculate total percentage (average)
  const totalPercentage = (
    pollData.reduce((sum, item) => sum + item.percentage, 0) / pollData.length
  ).toFixed(2);

  const [sortBy, setSortBy] = useState('rank');
  const [sortOrder, setSortOrder] = useState('asc');
  const [searchTerm, setSearchTerm] = useState('');

  const getSortedData = () => {
    let filtered = pollData.filter(item =>
      item.district.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return filtered.sort((a, b) => {
      let comparison = 0;
      
      if (sortBy === 'rank') {
        comparison = a.rank - b.rank;
      } else if (sortBy === 'name') {
        comparison = a.district.localeCompare(b.district);
      } else if (sortBy === 'percentage') {
        comparison = a.percentage - b.percentage;
      }

      return sortOrder === 'asc' ? comparison : -comparison;
    });
  };

  const sortedData = getSortedData();

  const getRankColor = (rank) => {
    if (rank === 1) return '#FFD700';
    if (rank === 2) return '#C0C0C0';
    if (rank === 3) return '#CD7F32';
    return '#667eea';
  };

  const getPercentageColor = (percentage) => {
    if (percentage >= 75) return '#10b981'; // Emerald green
    if (percentage >= 70) return '#22c55e'; // Green
    if (percentage >= 65) return '#3b82f6'; // Blue
    if (percentage >= 60) return '#f59e0b'; // Orange
    return '#ef4444'; // Red
  };

  return (
  <>
    <Header />
    <div className="pp-poll-percentage-page">
      <div className="pp-poll-header">
        <h1>
          <i className="fas fa-chart-line" aria-hidden="true"></i>
          {t('pollPercentage.title') || 'Poll Percentage'}
        </h1>
        <p className="pp-poll-subtitle">
          {t('pollPercentage.subtitle') || 'Bihar Legislative Assembly General Elections, 2025'}
        </p>
        {/* <div className="pp-phase-info">
          <span className="pp-phase-badge">
            <i className="fas fa-calendar-check" aria-hidden="true"></i>
            {t('pollPercentage.phase1') || '1st Phase'}
          </span>
          <span className="pp-date-badge">
            <i className="fas fa-clock" aria-hidden="true"></i>
            {t('pollPercentage.date') || 'Date'}: 06.11.2025
          </span>
          <span className="pp-time-badge">
            <i className="fas fa-stopwatch" aria-hidden="true"></i>
            {t('pollPercentage.time') || 'Time'}: 5:00 PM
          </span>
        </div> */}
      </div>

      <div className="pp-stats-container">
        <div className="pp-stat-card pp-total">
          <div className="pp-stat-icon">
            <i className="fas fa-percentage" aria-hidden="true"></i>
          </div>
          <div className="pp-stat-content">
            <h3>{t('pollPercentage.totalPercentage') || 'Average Poll Percentage'}</h3>
            <p className="pp-stat-value">{totalPercentage}%</p>
          </div>
        </div>

        <div className="pp-stat-card pp-districts">
          <div className="pp-stat-icon">
            <i className="fas fa-map-marked-alt" aria-hidden="true"></i>
          </div>
          <div className="pp-stat-content">
            <h3>{t('pollPercentage.totalDistricts') || 'Total Districts'}</h3>
            <p className="pp-stat-value">{pollData.length}</p>
          </div>
        </div>

        <div className="pp-stat-card pp-highest">
          <div className="pp-stat-icon">
            <i className="fas fa-trophy" aria-hidden="true"></i>
          </div>
          <div className="pp-stat-content">
            <h3>{t('pollPercentage.highest') || 'Highest Percentage'}</h3>
            <p className="pp-stat-value">{Math.max(...pollData.map(d => d.percentage))}%</p>
            <small>{pollData.find(d => d.rank === 1)?.district}</small>
          </div>
        </div>

        <div className="pp-stat-card pp-lowest">
          <div className="pp-stat-icon">
            <i className="fas fa-arrow-down" aria-hidden="true"></i>
          </div>
          <div className="pp-stat-content">
            <h3>{t('pollPercentage.lowest') || 'Lowest Percentage'}</h3>
            <p className="pp-stat-value">{Math.min(...pollData.map(d => d.percentage))}%</p>
            <small>{pollData.find(d => d.percentage === Math.min(...pollData.map(d => d.percentage)))?.district}</small>
          </div>
        </div>
      </div>

      <div className="pp-controls-container">
        <div className="pp-search-box">
          <i className="fas fa-search" aria-hidden="true"></i>
          <input
            type="text"
            placeholder={t('pollPercentage.searchDistrict') || 'Search district...'}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="pp-sort-controls">
          <label>{t('pollPercentage.sortBy') || 'Sort By'}:</label>
          <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
            <option value="rank">{t('pollPercentage.rank') || 'Rank'}</option>
            <option value="name">{t('pollPercentage.districtName') || 'District Name'}</option>
            <option value="percentage">{t('pollPercentage.percentage') || 'Percentage'}</option>
          </select>

          <button
            className="pp-sort-order-btn"
            onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
            title={sortOrder === 'asc' ? 'Ascending' : 'Descending'}
          >
            <i className={`fas fa-sort-amount-${sortOrder === 'asc' ? 'up' : 'down'}-alt`} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <div className="pp-poll-table-container">
        <table className="pp-poll-table">
          <thead>
            <tr>
              <th>{t('pollPercentage.rank') || 'Rank'}</th>
              <th>{t('pollPercentage.districtName') || 'District Name'}</th>
              <th>{t('pollPercentage.percentage') || 'Poll Percentage'}</th>
              <th>{t('pollPercentage.progress') || 'Progress'}</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((item, index) => (
              <tr key={index} className="pp-poll-row">
                <td>
                  <span 
                    className="pp-rank-badge" 
                    style={{ backgroundColor: getRankColor(item.rank) }}
                  >
                    {item.rank === 1 && <i className="fas fa-crown" aria-hidden="true"></i>}
                    {item.rank}
                  </span>
                </td>
                <td className="pp-district-name">{item.district}</td>
                <td>
                  <span 
                    className="pp-percentage-badge"
                    style={{ color: getPercentageColor(item.percentage) }}
                  >
                    {item.percentage}%
                  </span>
                </td>
                <td className="pp-progress-cell">
                  <div className="pp-progress-bar">
                    <div 
                      className="pp-progress-fill" 
                      style={{ 
                        width: `${(item.percentage / 80) * 100}%`,
                        backgroundColor: getPercentageColor(item.percentage)
                      }}
                    >
                      <span className="pp-progress-text">{item.percentage}%</span>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pp-total-row-container">
        <div className="pp-total-row">
          <span className="pp-total-label">
            <i className="fas fa-calculator" aria-hidden="true"></i>
            {t('pollPercentage.average') || 'AVERAGE'}
          </span>
          <span className="pp-total-percentage">{totalPercentage}%</span>
        </div>
      </div>

      <div className="pp-download-section">
        <button className="pp-download-btn" onClick={() => window.print()}>
          <i className="fas fa-download" aria-hidden="true"></i>
          {t('pollPercentage.downloadReport') || 'Download Report'}
        </button>
      </div>
    </div>
  </>
);
};

export default PollPercentage;